export default `<div class="mod mod-footer">
    <!--Super Market Store Demo Footer-->
    <div class="row visible-sm visible-md visible-lg">
        <img class="img-responsive center-block"
            src="//cdn.cpnscdn.com/static.coupons.com/Sites/riq/super-market-store/footer-image.png" />
    </div>
    <div class="row visible-xs mobile">
        <div class="col-xs-12">
            <img class="center-block"
                src="//cdn.cpnscdn.com/static.coupons.com/Sites/riq/super-market-store/footer-mobile1.png" />
        </div>
    </div>
</div>`;
